import { watch } from 'vue';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
const store = useMonitoringStore();
export const useAlarmVideoData = () => {
    const initAlarmDevice = () => {
        watch(() => store.alarmDeviceId, () => {
            const { alarmDeviceId, videoSettingArr } = store;
            if (!alarmDeviceId)
                return;
            const isSelected = videoSettingArr.find((item) => String(item.deviceId) === String(alarmDeviceId));
            store.updateAlarmDeviceId('');
            isSelected && updateVideoSettingData(alarmDeviceId, videoSettingArr);
        });
    };
    const resetVideoSettingStatue = (videoSettingArr) => {
        return videoSettingArr.map((item) => {
            return { ...item, isUpdate: false };
        });
    };
    const updateVideoSettingData = (alarmDeviceId, settingArr) => {
        const videoSettingArr = resetVideoSettingStatue(settingArr); // 重置update状态
        updateSingleSettingData({ id: alarmDeviceId }, videoSettingArr);
        updateSettingAnimation(videoSettingArr);
        store.updateVideoSettingArrData(videoSettingArr);
    };
    // 重置告警开始结束时间
    const updateSingleSettingData = (params, videoSettingArr) => {
        const currTaskId = String(store.alarmTaskId);
        const { id, parentId, linkStartTime, linkDuration } = params;
        const selectDeviceItem = store.videoDetailArr.find((item) => String(item.deviceId || item.id) === String(id) &&
            item.taskType === 'FACE_ALERT' &&
            (parentId || item.taskId === currTaskId)); // 当前需选中人脸比重算法图层
        const currSettingData = videoSettingArr.find((item) => String(item.deviceId) === String(id));
        if (!currSettingData)
            return;
        const currDate = Math.floor(Date.now() / 1000);
        const { alertEndTime, currentDeviceAlertDuration = 10, linkageDevice, linkageDeviceAlertDelayTime = 0, linkageDeviceAlertDuration, alertStartTime, } = currSettingData;
        currSettingData.isUpdate = true;
        let startTime, endTime;
        if (selectDeviceItem) {
            if (!alertEndTime || alertEndTime < currDate) {
                // 第一次告警 || 告警已结束
                currSettingData.alertStartTime = linkStartTime || currDate; // 告警开始时间为当前时间，如果是联动装置加上联动装置延迟时间
                currSettingData.alertEndTime = linkStartTime ? linkStartTime + Number(linkDuration) : currDate + currentDeviceAlertDuration; // 结束时间：如果是联动装置，则为当前时间+联动延迟+联动报警时长，如果非联动装置，则为当前时间+报警时长
            }
            else if (Number(alertStartTime) <= currDate) {
                // 已开始告警且告警未结束，只需要更新告警结束时间
                const endTime = linkStartTime
                    ? Math.max(linkStartTime + Number(linkDuration) || 0, alertEndTime)
                    : currDate + currentDeviceAlertDuration; // 联动和非联动分开计算
                currSettingData.alertEndTime = endTime;
                currSettingData.alertStartTime = currDate;
            }
            else {
                // 未开始告警
                startTime = linkStartTime ? Math.min(linkStartTime, Number(alertStartTime)) : currDate;
                endTime = linkStartTime
                    ? Math.max(linkStartTime + Number(linkDuration), alertEndTime)
                    : Math.max(startTime + currentDeviceAlertDuration, alertEndTime);
                currSettingData.alertStartTime = startTime;
                currSettingData.alertEndTime = endTime;
            }
            if (Number(alertStartTime) < currDate && Number(currSettingData?.alertStartTime) >= currDate) {
                currSettingData.change = !currSettingData?.change;
            }
            if (linkageDevice && !parentId && linkageDevice !== parentId) {
                const linkStartTime = Number(currSettingData?.alertStartTime) + linkageDeviceAlertDelayTime;
                updateSingleSettingData({ id: linkageDevice, parentId: id, linkStartTime, linkDuration: linkageDeviceAlertDuration }, videoSettingArr);
            }
        }
        else {
            currSettingData.alertStartTime = currDate;
            currSettingData.alertEndTime = currDate;
            currSettingData.change = !currSettingData?.change;
        }
    };
    // 重置告警设备框动画参数
    const updateSettingAnimation = (videoSettingArr) => {
        const currDate = Math.floor(Date.now() / 1000);
        videoSettingArr.forEach((item) => {
            if (!item.isUpdate)
                return;
            const { alertStartTime, alertEndTime, change, animationDelay } = item;
            item.animationDelay = Number(alertStartTime) >= currDate ? Number(alertStartTime) - currDate : Number(animationDelay);
            item.animationName = change ? 'linkmove' : 'linkmove2';
            item.animationDuration = Number(alertEndTime) - Number(alertStartTime);
        });
    };
    const getStyle = (node, index) => {
        const currSettingData = store.videoSettingArr.find((item) => item.deviceId === node.id);
        if (!currSettingData)
            return;
        const { animationDelay, animationName, animationDuration, change } = currSettingData;
        return {
            animationDelay: `${animationDelay}s`,
            animationName,
            animationDuration: `${animationDuration}s`,
            animationFillMode: 'forwards',
            animationTimingFunction: 'linear',
            change,
        };
    };
    return { initAlarmDevice, getStyle };
};
